/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as core from '../../core';
import * as errors from '../../errors/index';
import * as Truvity from '../index';

export class TooManyRequestsError extends errors.TruvityError {
    constructor(body: Truvity.TooManyRequestsProblems, rawResponse?: core.RawResponse) {
        super({
            message: 'TooManyRequestsError',
            statusCode: 429,
            body: body,
            rawResponse: rawResponse,
        });
        Object.setPrototypeOf(this, TooManyRequestsError.prototype);
    }
}
